import {
    current
} from "@/api/auth";
import {
    useAuthStore
} from "@/stores";
import { ref } from "vue";
import { useRouter } from "vue-router";

export default () => {

    const store = useAuthStore();
    const isFetching = ref(false);
    const router = useRouter();
    const success = async (response) => {

        if (response.data.code != 'SUCCESS') {
            return false;
        }

        const user = response.data.data.user;
        const currentUser = store.user;
        
        if(!['admin'].includes(user.role) && !user.is_completed) {
            router.push({ name: 'onboarding' });
        }

        store.setUser(user, true);
        
        if(currentUser.role != user.role) {
            router.push({ name: 'home' });
        }


        if (response.data.data.acting_company?.id) {
            store.setCompany(response.data.data.acting_company);
        } else {
            store.setCompany(null);
        }
        

        return true;
    }

    const failed = async (error) => {

        if (error?.response?.data?.code != 'SUCCESS') {
            // If session is invalid, logout the user
            if (error?.response?.status === 401) {
                store.logout();
            }
            return false;
        }

    }


    const check = async () => {
        isFetching.value = true;
        await current()
        .then(success)
        .catch(failed)
        isFetching.value = false;
    }


    return {
        check,
        isFetching,
    }

}